import React, { Component} from "react";
import { NavLink} from "react-router-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  FormGroup,
  FormControl,
  InputGroup
} from "react-bootstrap";
import SweetAlert from 'react-bootstrap-sweetalert';
import LoginKioskPage from "../../views/Pages/LoginKioskPage";

class HeaderLinks extends Component {
    constructor(props) {
        super(props);
        //bind the login event handler to this instance so it can have scope on props and state
        this.logUserOut = this.logUserOut.bind(this);
        this.activeRoute = this.activeRoute.bind(this);
        this.successAlert = this.successAlert.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        //Clear the Alert state
        this.state = {
            alert: null
        }
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    successAlert(){
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block"}}
                    title="You have been logged out!"
                    onConfirm={() => this.setState({alert: null})}
                    onCancel={() => this.setState({alert: null})}
                    confirmBtnBsStyle="info"
                >
                </SweetAlert>
            )
        });
        setTimeout(this.hideAlert, 3000);
    }

    // lets do a Thunk call to set the status to logged out.
    logUserOut(event) {
        //event.preventDefault();
        this.props.actions.logUserOut({
            Userid: "",
            Email: "",
            Fname: "",
            Lname: "",
            status: false,
            role: "",
            _id:""
        });
        this.successAlert();
        this.context.router.history.push("/Home")
    }
    //Grab some route context for redirections
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    // function that sets the class to active of the active page
    activeRoute(routeName) {
        return window.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }

    render() {
    const loginLink = this.props.userLoggedIn[0].status ? (
        <div>
            <MenuItem eventKey={4.5} onSelect={this.logUserOut}>
                <div className="text-danger">
                    <i className="pe-7s-close-circle" />Tenant Log out
                </div>
            </MenuItem>
        </div>
        ) : (
        <div className={this.activeRoute("login-page")}>
            <NavLink to={"/pages/login-page"} className="nav-link">
                <i className="pe-7s-user" />Tenant Log In
            </NavLink>
        </div>
        );
    const loginKioskLink = ((!this.props.userLoggedIn[0].status) &&  (this.props.userLoggedIn[0].role === "Kiosk")) ? (
            <div>
                <MenuItem eventKey={4.5} onSelect={this.logUserOut}>
                    <div className="text-danger">
                        <i className="pe-7s-close-circle" />Kiosk Log out
                    </div>
                </MenuItem>
            </div>
        ) : (
            <div className={this.activeRoute("login-page")}>
                <NavLink to={"/pages/login-kiosk-page"} className="nav-link">
                    <i className="pe-7s-note2" />Kiosk Log In
                </NavLink>
            </div>
        );
        const registerLink = (!this.props.userLoggedIn[0].status) ? (
            <div className={this.activeRoute("register")}>
                <NavLink to={"register"} className="nav-link">
                    <i className="pe-7s-add-user" />Register
                </NavLink>
            </div>
        ) : (<div></div>);

        const pricingLink = (!this.props.userLoggedIn[0].status) ? (
            <div className={this.activeRoute("pricing-page")}>
                <NavLink to={"/pages/pricing-page"} className="nav-link">
                    <i className="pe-7s-cash" />Pricing
                </NavLink>
            </div>
        ) : (<div></div>);

        const subscriptionStatus = ((this.props.userLoggedIn[0].status) || (this.props.userLoggedIn[0].role === "Kiosk")) ? (
            ( this.props.userLoggedIn[0].subscription) ? (
                <NavItem eventKey={3} href="#">
                    <i className="fa fa-unlock"/>
                    <p>Subscription Status: Active</p>
                </NavItem>
            ) : (
                <NavItem eventKey={3} href="#">
                    <i className="fa fa-lock"/>
                    <p>Subscription Status: Expired</p>
                </NavItem>
            )
        ) : (
            <NavItem eventKey={3} href="#">
            </NavItem>

        );
    /*
        const subscriptionStatus = ((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription !== "Expired")) ? (
            <NavItem eventKey={3} href="#">
                <i className="fa fa-line-chart"/>
                <p>Subscription Status: Active</p>
            </NavItem>
        ) : (
            <NavItem eventKey={3} href="#">
                <i className="fa fa-line-chart"/>
                <p>Subscription Status: Expired</p>
            </NavItem>

        );*/
   // }
   /* else {
        const subscriptionStatus = (
            <NavItem eventKey={3} href="#">
            </NavItem>
        )
    }*/
    return (
      <div>
          {/*
        <Navbar.Form pullLeft className="navbar-search-form">
          <FormGroup>
            <InputGroup>
              <InputGroup.Addon>
                <i className="fa fa-search" />
              </InputGroup.Addon>
              <FormControl type="text" placeholder="Search..." />
            </InputGroup>
          </FormGroup>
        </Navbar.Form>*/}
        <Nav pullRight>

          {subscriptionStatus}
            {/*
          <NavDropdown
            eventKey={2}
            title={
              <div>
                <i className="fa fa-gavel" />
                <p className="hidden-md hidden-lg">
                  Actions
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-1"
          >
            <MenuItem eventKey={2.1}>Create New Post</MenuItem>
            <MenuItem eventKey={2.2}>Manage Something</MenuItem>
            <MenuItem eventKey={2.3}>Do Nothing</MenuItem>
            <MenuItem eventKey={2.4}>Submit to live</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={2.5}>Another action</MenuItem>
          </NavDropdown>
          <NavDropdown
            eventKey={3}
            title={
              <div>
                <i className="fa fa-bell-o" />
                <span className="notification">5</span>
                <p className="hidden-md hidden-lg">
                  Notifications
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-2"
          >
            <MenuItem eventKey={3.1}>Notification 1</MenuItem>
            <MenuItem eventKey={3.2}>Notification 2</MenuItem>
            <MenuItem eventKey={3.3}>Notification 3</MenuItem>
            <MenuItem eventKey={3.4}>Notification 4</MenuItem>
            <MenuItem eventKey={3.5}>Another notifications</MenuItem>
          </NavDropdown>*/}
          <NavDropdown
            eventKey={4}
            title={
              <div>
                <i className="fa fa-list" />
                <p className="hidden-md hidden-lg">
                  More
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-3"
            bsClass="dropdown-with-icons dropdown"
          >
              {/*
            <MenuItem eventKey={4.1}>
              <i className="pe-7s-mail" /> Messages
            </MenuItem>
            <MenuItem eventKey={4.2}>
              <i className="pe-7s-help1" /> Help Center
            </MenuItem>
            <MenuItem eventKey={4.3}>
              <i className="pe-7s-tools" /> Settings
            </MenuItem>
            <MenuItem divider />

            <MenuItem eventKey={4.4}>
                <div className={this.activeRoute("lock-screen-page")}>
                    <NavLink to={"/pages/lock-screen-page"} className="nav-link">
                        <i className="fa fa-lock" />
                        <p>Lock Screen</p>
                    </NavLink>
                </div>
            </MenuItem>*/}
            <MenuItem divider />
            {loginLink}
            <MenuItem divider />
            {loginKioskLink}
            <MenuItem divider />
              {registerLink}
              <MenuItem divider />
              {pricingLink}
            <MenuItem divider />
              {/* <NavItem eventKey={3} href="https://www.eayardwork.com/#/pages/login-page"><i className="fa fa-line-chart" /><p>Login Page</p></NavItem>*/}
              {this.state.alert}
              {/*}
            <MenuItem eventKey={4.5}>
                <div className={this.activeRoute("login-page")}>
                    <NavLink to={"/pages/login-page"} className="nav-link">
                      <i className="fa fa-drivers-license-o" />  {this.props.isLoggedIn ? 'Log out' : 'Log in'}
                    </NavLink>
                </div>
            </MenuItem> */}

              {/*
            <MenuItem eventKey={4.5} onSelect={this.handleLoginLogout}>
              <div className="text-danger">

                    <i className="pe-7s-close-circle" /> {this.props.isLoggedIn ? 'Log out' : 'Log in'}
              </div>
                <li className={this.activeRoute("login-page")}>
                    <NavLink to={"/pages/login-page"} className="nav-link">
                        <i className="fa fa-drivers-license-o" />  {this.props.isLoggedIn ? 'Log out' : 'Log in'}
                    </NavLink>
                </li>
            </MenuItem>*/}
          </NavDropdown>
        </Nav>
      </div>
    );
  }
}


HeaderLinks.propTypes = {
    actions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    //debugger;
    return {
        userLoggedIn: state.userLoggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(loginActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLinks);


//export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx